import React from 'react';
import ListContainer from './styles';
import Tab from '../../../../../components/Tab';
import OpinionCard from '../../../../../components/Cards/Opinion';
import { opinions } from '../../../../../utils';
import { useTranslation } from 'react-i18next';

const OpinionsList = () => {
	const { t } = useTranslation();

	const getItems = () => {
		return opinions.map(opinion => {
			return {
				component: (
					<OpinionCard
						image={opinion.image}
						name={t(opinion.name)}
						description={t(opinion.description)}
					/>
				)
			};
		});
	};

	return (
		<ListContainer>
			<Tab items={getItems()} showTitleTab={false} />
		</ListContainer>
	);
};

export default OpinionsList;
